import type { PlanFeaturesSnapshot } from "./types";

export function countPlansInFeaturesSnapshot(snapshot: PlanFeaturesSnapshot): number {
  const ids = new Set<string>();
  for (const section of snapshot.sections ?? []) {
    for (const plan of section.plans ?? []) {
      if (plan.planId) ids.add(plan.planId);
    }
  }
  return ids.size;
}
